export default function injectFonts() {
  const iconFontStyles = `
@font-face {
  src: url(${require('react-native-vector-icons/Fonts/FontAwesome.ttf')});
  font-family: FontAwesome;
}
@font-face {
  src: url(${require('react-native-vector-icons/Fonts/Entypo.ttf')});
  font-family: 'Entypo';
}
@font-face {
  src: url(${require('react-native-vector-icons/Fonts/MaterialIcons.ttf')});
  font-family: MaterialIcons;
}
@font-face {
  src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')});
  font-family: MaterialCommunityIcons;
}
@font-face {
  src: url(${require('react-native-vector-icons/Fonts/Ionicons.ttf')});
  font-family: Ionicons;
}
@font-face {
  src: url(${require('../../modules/Navigator/assets/manage-my-pain.ttf')});
  font-family: 'manage-my-pain';
}`;

  // Create stylesheet
  const style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = iconFontStyles;
  } else {
    style.appendChild(document.createTextNode(iconFontStyles));
  }

  // Inject stylesheet
  document.head.appendChild(style);
}
